import type React from "react";
import { Badge } from "@similarweb/ui-components";
import { StyledBetaItemWrapper, StyledBetaTag, StyledChildrenWrapper } from "./StyledComponent";

export const BetaWrapper = ({ isBeta, children }: React.PropsWithChildren<{ isBeta: boolean }>) => (
    <StyledBetaItemWrapper>
        <StyledChildrenWrapper>{children}</StyledChildrenWrapper>
        {isBeta ? (
            <StyledBetaTag>
                <Badge type="beta" />
            </StyledBetaTag>
        ) : null}
    </StyledBetaItemWrapper>
);
